(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvDialogFooter', drvDialogFooter);

    function drvDialogFooter() {
        var directive = {
            restrict: 'E',
            transclude: true,
            replace: true,
            template:
                '<div class="modal-footer">' +
                '  <ng-transclude></ng-transclude>' +
                '</div>'
        };
        return directive;
    }
})();